import {defineStore} from "pinia";
import {Hotel} from "models/global/Hotel";
import {User} from "models/global/User";
import {ApplicationGroup} from "models/global/ApplicationGroup";
import {Application} from "models/global/Application";
import {UserRegistry} from "models/global/UserRegistry";
import {Toast} from "models/global/Toast";

export interface GlobalStore {
	applications: ApplicationGroup[]
	activeGroupController: string | null
	activeController: string
	application: Application | null
	formkit: any
	user: User,
	hotels: Hotel[],
	currentHotel: Hotel,
	domainHotels: Hotel[],
	registries: UserRegistry[],
	favorites: Application[],
	unreadNotifications: number,
	connection: {
		status: string,
		list: []
	},
	announcement: boolean | object,
	toasts: Toast[],
}

export const globalStore = defineStore('globalStore', {
	state: (): GlobalStore => {
		return {
			applications: [],
			activeGroupController: '',
			activeController: '',
			application: null,
			formkit: null,
			user: new User(),
			hotels: [],
			currentHotel: new Hotel(),
			domainHotels: [],
			registries: [],
			favorites: [],
			unreadNotifications: 0,
			connection: {
				status: "",
				list: []
			},
			announcement: false,
			toasts: [],
		}
	},
	getters: {},
	actions: {
		setApplications(applications) {
			this.applications = applications;
		},
		setActiveGroupController(controller: string | null) {
			this.activeGroupController = controller;
		},
		setActiveController(controller) {
			this.activeController = controller;
		},
		setUser(user) {
			this.user = user;
		},
		setHotels(hotels) {
			this.hotels = hotels;
		},
		setCurrentHotel(currentHotel) {
			this.currentHotel = currentHotel;
		},
		setDomainHotels(hotels) {
			this.domainHotels = hotels;
		},
		setApplication() {
			// Try to find application in groups
			for (let i = 0; i < this.applications.length; i++) {
				const group = this.applications[i];
				if (group.children) {
					for (let j = 0; j < group.children.length; j++) {
						const application = group.children[j];
						if (application.controller === this.activeController) {
							this.application = application;
							return;
						}
						if (application.children) {
							for (let k = 0; k < application.children.length; k++) {
								const child = application.children[k];
								if (child.controller === this.activeController) {
									this.application = child;
									this.activeGroupController = group.controller;
									this.activeController = application.controller;
									return;
								}
							}
						}
					}
				}
			}
		},
		hasApplication(application) {
			//TODO
			let found = false;

			this.applications.forEach((group) => {
				if (group?.controller === application) {
					found = true;
					return true
				}

				if (group?.children?.length) {
					group?.children.forEach((child) => {
						if (child.controller === application) {
							found = true;
							return true;
						}
					})
				}
			})

			return found
		},
		setApplicationFavorite(state: boolean) {
			this.application.favorite = state
		},
		setRegistries(registries: UserRegistry[]) {
			this.registries = registries
			window["registries"] = registries
		},
		setFavorites(favorites: Application[]) {
			this.favorites = favorites
		},
		setUnreadNotifications(unreadNotifications: number) {
			this.unreadNotifications = unreadNotifications
		},
		setConnection(connection: { status: string, list: [] }) {
			if (!connection) {
				return
			}
			this.connection.status = connection.status
			this.connection.list = connection.list
		},
		setAnnouncement(announcement: object) {
			if (!announcement) {
				return
			}
			this.announcement = announcement
		},
		addToast(toast: Toast) {
			this.toasts.push(toast);
			setTimeout(() => {
				const key = this.toasts.findIndex(loopToast => loopToast.id === toast.id);
				this.toasts.splice(key, 1);
			}, toast.duration * 1000);
		},
		removeToast(id: number) {
			const key = this.toasts.findIndex(loopToast => loopToast.id === id);
			this.toasts.splice(key, 1);
		},
		removeProfilePicture() {
			this.user.croppedProfilePicture = "";
			this.user.originalProfilePicture = "";
		},
	}
})